import {ToastLevel} from "../../../apis/backend";

export const ToastLevelDisplayValues: Record<ToastLevel, string> = {
    Light: 'Light',
    Medium: 'Medium',
    Heavy: 'Heavy',
}